import { graphql } from '@/gql'

export const GetWorkerTrustedContactsQuery = graphql(/* GraphQL */ `
  query trustedContacts($accounts: [ID!], $workers: [ID!], $first: Int!) {
    trustedContacts(accounts: $accounts, workers: $workers, first: $first) {
      data {
        ...TrustedContactLookup
      }
    }
  }
`)
